import { styled } from "../theme";
/**
 * A card component with a border, rounded corners, and padding.
 */
export const Card = styled.div `
  border: 1px solid ${({ theme }) => theme.color.gray10};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.color.white};
  padding: 20px;
  padding-top: 0px;
  margin-bottom: 20px;
`;
